import axios from "axios";
import authHeader from "./auth-header";

function getValoresPeriodo(body) {
  return axios.post(
    "https://api.kairosmining.com/api/Tostacion/getValoresPeriodo",
    body,
    {
      headers: authHeader(),
    }
  );
}

function getDatosAAQQ(body) {
  return axios.post(
    "https://api.kairosmining.com/api/Tostacion/getDatosAAQQ",
    body,
    {
      headers: authHeader(),
    }
  );
}

/**
 *  Sp para crear las tablas de configuraciones
 * @param {*} body
 * @returns
 */
function getParametrosModelos(body) {
  return axios.post(
    "https://api.kairosmining.com/api/Tostacion/getParametrosModelos",
    body,
    {
      headers: authHeader(),
    }
  );
}

/**
 *
 * @param {*} body
 * @returns
 */
function setParametroModelo(body) {
  return axios.post(
    "https://api.kairosmining.com/api/Tostacion/setParametroModelo",
    body,
    {
      headers: authHeader(),
    }
  );
}

/**
 * Recibe una secuencia y un periodo
 * @param {*} body
 * @returns
 */
function getConsolidadoPeriodo(body) {
  return axios.post(
    "https://api.kairosmining.com/api/Tostacion/getConsolidadoPeriodo",
    body,
    {
      headers: authHeader(),
    }
  );
}

/**
 *
 * @param {*} body - recibe un parametro theta
 * @returns
 */
function getResultadoDomo(body) {
  return axios.post(
    "https://api.kairosmining.com/api/Tostacion/getResultadosDomo",
    body,
    {
      headers: authHeader(),
    }
  );
}

function getResultadosDomoAjustesAAQQ(body) {
  return axios.post(
    "https://api.kairosmining.com/api/Tostacion/getResultadosDomoAjustesAAQQ",
    body,
    {
      headers: authHeader(),
    }
  );
}

export {
  getValoresPeriodo,
  getResultadosDomoAjustesAAQQ,
  getDatosAAQQ,
  getResultadoDomo,
  getParametrosModelos,
  setParametroModelo,
  getConsolidadoPeriodo,
};
